/**
 * 删除url上的query参数
 * @param param 需要删除的key
 */
export function deleteUrlQuery(param: string | string[]) {
  try {
    const paramArr = Array.isArray(param) ? param : [param]
    const url = new URL(window.location.href)
    paramArr.forEach((p) => {
      url.searchParams.delete(p)
    })
    history.replaceState(null, null, url)
  } catch (error) {}
}
